import { useContext, useState } from "react";
import { RadioInputGroup, RadioInput } from "../radio-input";
import { StepActions } from "./step-actions";
import { StepperContext } from "./stepper";
import { SubtitleOption } from "src/models/subtitle-option.model";

interface DownloadSubtitleOptionSelectProps {
  selectSubtitleOption: (option: SubtitleOption) => void;
}

const SUBTITLE_OPTIONS: { value: string; label: { __html: string } }[] = [
  { value: SubtitleOption.None, label: { __html: "Untertitel <b>nicht</b> mit herunterladen" } },
  { value: SubtitleOption.Included, label: { __html: "Untertitel <b>fest verankert</b> herunterladen" } },
  { value: SubtitleOption.Separated, label: { __html: "Untertitel <b>als separate Datei</b> herunterladen" } },
];

export function DownloadSubtitleOptionSelect({ selectSubtitleOption }: DownloadSubtitleOptionSelectProps) {
  const { step, nextStep, cancel } = useContext(StepperContext);
  const [selectedOption, setSelectedOption] = useState<string | null>(null);

  const active = step === 2;

  const handleSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault();
    if (selectedOption) {
      selectSubtitleOption(selectedOption as SubtitleOption);
      nextStep();
    }
  };

  return (
    <div className="flex flex-col">
      <form className="mb-0" onSubmit={handleSubmit}>
        <RadioInputGroup
          label="Wie möchten Sie mit Untertiteln verfahren?"
          name="subtitle"
          handleChange={setSelectedOption}
        >
          {SUBTITLE_OPTIONS.map((option, index) => {
            return (
              <RadioInput
                key={`subtitle-option-${index}`}
                value={option.value}
                checked={option.value === selectedOption}
                disabled={!active}
              >
                <span dangerouslySetInnerHTML={option.label}></span>
              </RadioInput>
            );
          })}
        </RadioInputGroup>

        <StepActions
          cancelLabel="Abbrechen"
          cancelDisabled={!active}
          handleCancel={cancel}
          nextLabel="Weiter"
          nextDisabled={!active || !selectedOption}
        />
      </form>
    </div>
  );
}
